export default __webpack_public_path__ + "static/media/openvino-2.0215cab1.svg";